import { render, staticRenderFns } from "./SVGPutToTemplateModal.vue?vue&type=template&id=7225778e"
import script from "./SVGPutToTemplateModal.vue?vue&type=script&lang=js"
export * from "./SVGPutToTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SVGPutToTemplateModal.vue?vue&type=style&index=0&id=7225778e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports